import { useAppDispatch } from '@/hooks'
import { referralsCollection } from '@/reducers/referrals'
import { Referral } from '@/types/referral'
import { Transaction } from '@/types/transaction'
import { fetchAuthenticated } from '@/utils/fetch'
import { useEffect, useState } from 'react'
import { ViewModelProps } from '../../rewards.viewmodel'
import { getProgramNamesWithExternalPayouts } from './Activity.utils'

export type ActivityViewModelProps = ReturnType<typeof useActivityViewModel>

export function useActivityViewModel(parentProps: ViewModelProps) {
  const dispatch = useAppDispatch()

  const [reminderModalOpen, setReminderModalOpen] = useState(false)
  const [loadedTransactions, setLoadedTransactions] = useState(5)
  const [transactionToDisplay, setTransactionToDisplay] =
    useState<Transaction | null>(null)

  const programNamesWithExternalPayouts = getProgramNamesWithExternalPayouts(
    parentProps.programOverviews,
  )

  const sendReminder = (referral: Referral) => {
    if (!referral.can_remind) return
    fetchAuthenticated(`referrals/${referral.id}/remind`, {
      method: 'PATCH',
    }).then(() => {
      setReminderModalOpen(true)
    })
  }

  const onReminderClose = () => {
    dispatch(referralsCollection.actions.fetch())
    setReminderModalOpen(false)
  }

  const loadMore = () => {
    console.log('loading more transactions', loadedTransactions)
    setLoadedTransactions((prev) => prev + 10)
  }

  useEffect(() => {
    parentProps.setRewardError(null)
    return () => {
      parentProps.setRewardError(null)
    }
  }, [])

  return {
    ...parentProps,
    reminderModalOpen,
    sendReminder,
    onReminderClose,
    loadedTransactions,
    loadMore,
    transactionToDisplay,
    setTransactionToDisplay,
    programNamesWithExternalPayouts,
  }
}
